<template>
  <div class="dashboard-tabla-resultados">
    <div class="dashboard-tabla-resultados-header">
      <h4>Resumen de Deuda de Clientes</h4>
      <p class="link" 
        @click.stop="exportarResumenDeuda"><i class="fa fa-file-excel-o"></i>Exportar Resumen</p>
    </div>
    <div class="dashboard-tabla-resultados-data">
      <b-table hover
          responsive="sm" 
          class="table-dashboard"
          :busy="tableBusy"
          :items="resumenDeuda" 
          :fields="fields">
        <div slot="table-busy" class="text-center">
          <b-spinner class="table-spinner" label="Spinning" />
        </div>              
        <template v-slot:cell(deudaVencidaPesos)="data">
          {{ data.item.deudaVencidaPesos | moneda }}
        </template>
        <template v-slot:cell(deudaVencerPesos)="data">
          {{ data.item.deudaVencerPesos | moneda }}
        </template>
        <template v-slot:cell(deudaVencidaDolares)="data">
          {{ data.item.deudaVencidaDolares | moneda('u$s') }}
        </template>
        <template v-slot:cell(deudaVencerDolares)="data">
          {{ data.item.deudaVencerDolares | moneda('u$s') }}
        </template>
      </b-table>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs';

export default {
  name: 'DashboardDeudaClientes',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      resumenDeuda: [],

      fields: [
        { 
          key: 'cliente',
        },
        {
          key: 'deudaVencidaPesos',
          label: 'Vencido',
          class: 'text-right',
        },
        {
          key: 'deudaVencerPesos',
          label: 'A Vencer',
          class: 'text-right',
        },
        {
          key: 'deudaVencidaDolares',
          label: 'Vencido',
          class: 'text-right',
        },
        {
          key: 'deudaVencerDolares',
          label: 'A Vencer',
          class: 'text-right',
        },
      ],

      tableBusy: false,
    }
  },
  methods: {
    getResultados() {
      this.tableBusy = true;
      this.$store.dispatch('cuentacorrienteclientes/getRptResumenDeuda')
        .then(() => {
          this.tableBusy = false;
          this.resumenDeuda = this.$store.getters['cuentacorrienteclientes/rptResumenDeuda'];
        })
        .catch(error => this.showErrorMsj(error));
    },
    exportarResumenDeuda() {
      let exportXls = Boolean(false); 

      if (this.resumenDeuda) {
        if (this.resumenDeuda.length != 0) {
          exportXls = Boolean(true);
        }
      }
      if (exportXls) {
        /* Excluimos la fila de totales */
        let resumen = this.resumenDeuda.filter(cliente => cliente.clienteId != 1);

        let title= 'Resumen de Deuda';
        let fileName = 'resumen-deuda-clientes';
        let format = [
          { titulo: 'Cliente', nombre: 'cliente', formato: '' },
          { titulo: 'Vencido - $', nombre: 'deudaVencidaPesos', formato: '' },
          { titulo: 'A Vencer - $', nombre: 'deudaVencerPesos', formato: '' },
          { titulo: 'Vencido - U$D', nombre: 'deudaVencidaDolares', formato: '' },
          { titulo: 'A Vencer - U$D', nombre: 'deudaVencerDolares', formato: '' },
        ];

        this.exportXLS(title, fileName, resumen, format);
      } else {
        this.showModalMsj('No hay datos para exportar', null, null, 'light')
      }
    }
  },
  watch: {
  }    
}
</script>

<style>
</style>
